import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Rss } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Page, PageHead } from "@/components/hub/Common";
import { ClipTile } from "@/pages/CreatorProfile";
import { RankBadge } from "@/components/landing/ClipVisuals";
import { GridSkeleton } from "@/components/Skeletons";

export default function Following() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/feed").then((r) => setData(r.data)).catch(() => setData({ creators: [], clips: [] })); }, []);
  return (
    <Page>
      <div data-testid="following-page">
        <PageHead label={t("fw.label")} t1={t("fw.title1")} t2={t("fw.title2")} sub={t("fw.sub")} />
        {data === null && <GridSkeleton testid="following-skeleton" />}
        {data && !data.creators.length && (
          <div className="cx-card rounded-3xl p-10 mt-10 text-center" data-testid="following-empty">
            <Rss className="w-8 h-8 text-[#3ad7ff] mx-auto" />
            <p className="text-slate-400 mt-4 max-w-md mx-auto">{t("fw.empty")}</p>
            <Link to="/vitrine" className="cx-btn rounded-full px-6 py-3 inline-block mt-6 text-sm font-semibold" data-testid="following-discover-btn">{t("fw.discover")}</Link>
          </div>
        )}
        {data && data.creators.length > 0 && (<>
          <div className="cx-label mt-10">{t("fw.creators")}</div>
          <div className="flex flex-wrap gap-2 mt-3" data-testid="following-creators">
            {data.creators.map((c) => (
              <Link key={c.handle} to={`/u/${c.handle}`} data-testid={`following-creator-${c.handle}`}
                className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] pl-1.5 pr-4 py-1.5 text-sm hover:border-[#2f7bff]/50 transition-colors">
                <span className="w-7 h-7 rounded-full bg-gradient-to-br from-[#2f7bff] to-[#a746ff] grid place-items-center text-xs font-bold">{c.display_name.slice(0, 1).toUpperCase()}</span>
                <span className="text-white">{c.display_name}</span>
                {c.badge && <RankBadge badge={c.badge} testid={`following-badge-${c.handle}`} />}
              </Link>
            ))}
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-4 sm:gap-5 mt-8" data-testid="following-feed">
            {data.clips.map((g, i) => <ClipTile key={g.share_id} g={g} i={i} prefix="feed" />)}
            {!data.clips.length && <p className="col-span-full text-slate-500" data-testid="following-no-clips">{t("fw.no_clips")}</p>}
          </div>
        </>)}
      </div>
    </Page>
  );
}
